module.exports = __webpack_public_path__ + "static/house-1-3167b96868e94e25f4d304e999f8c634.png";